/** Light glass dropdown panel — Console api.ts DROPDOWN_PANEL_STYLE */
export const QAWAEM_DROPDOWN_PANEL_STYLE = {
  background: 'rgba(255, 255, 255, 0.92)',
  backdropFilter: 'blur(14px)',
  WebkitBackdropFilter: 'blur(14px)',
  boxShadow: '0 12px 32px rgba(46, 69, 46, 0.1)',
};

/** Console TableToolbarLayout tableToolbarFilterBtn */
export const QAWAEM_TABLE_TOOLBAR_FILTER_BTN =
  'glass-input qawaem-toolbar-filter flex items-center gap-1.5 px-3 py-2 border rounded-lg hover:border-[#6e9b6e]/30 transition-all text-console text-sm shrink-0';
